import type { PropsWithChildren } from "react";

import Navbar from "../shared/app-navigation/navbar";

import { CompanyInit } from "./company-init";
import { MainLayout } from "./main-layout";

export const AccountingLayout = ({
  children,
  location,
}: PropsWithChildren<{ location: string[] }>) => {
  return (
    <MainLayout>
      <CompanyInit>
        <div className="flex flex-col h-full w-full gap-4">
          <Navbar location={location} />
          {children}
        </div>
      </CompanyInit>
    </MainLayout>
  );
};
